import { Link, Outlet } from "react-router-dom";
import Forums from "./routes/forums"

function App() {
  return (
    <div>
      <Forums />
    </div>
  );
}

export default App;
